import i18n from "../i18n";
import * as Yup from "yup";

export const createWarehouseInOutPermitSchema = (
  isGeneralDescriptionOther: boolean,
  isAttachments: {
    haveEscortingEmployeeId: number;
  }
) => {
  return Yup.object({
    exitFromBuilding: Yup.string(),
    entryIntoBuilding: Yup.string(),

    escortEmployee: Yup.string().required(
      i18n.language === "en"
        ? "Escorting employee is required."
        : "الموظف المرافق مطلوب."
    ),
    uploadEscortingEmployeeIDCard: Yup.mixed().when([], {
      is: () => isAttachments.haveEscortingEmployeeId,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "Escorting employee ID card is required."
            : "بطاقة هوية الموظف المرافق مطلوبة."
        ),
    }),
    permitStartDate: Yup.string().required(
      i18n.language === "en"
        ? "Permit start date is required."
        : "تاريخ بدء التصريح مطلوب."
    ),
    permitEndDate: Yup.string().required(
      i18n.language === "en"
        ? "Permit end date is required."
        : "تاريخ انتهاء التصريح مطلوب."
    ),
    generalDescriptionOther: Yup.string().when([], {
      is: () => !isGeneralDescriptionOther,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "General description (Other) is required."
            : "الوصف العام (أخرى) مطلوب."
        ),
    }),
  });
};
